import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { Button, Icon } from '@shiftfinancial/design-system';
import { SearchIcon } from '@shiftfinancial/react-icons/system';

import AbnAutoSuggest from '../AbnAutoSuggest';
import AbnGrid from '../AbnGrid';
import styles from './abnsearchstyles';

class AbnSearch extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      gridData: null,
      gridSelectedRowId: null,
      showGrid: false,
      searchResult: {
        keyword: null,
        isLoading: false,
        rows: [],
        error: null,
      },
    };

    this.handleSearchAbn = this.handleSearchAbn.bind(this);
    this.handleShowSearchResultGrid = this.handleShowSearchResultGrid.bind(this);
    this.handleRowSelection = this.handleRowSelection.bind(this);
    this.handleSuggestionSelection = this.handleSuggestionSelection.bind(this);
    this.handleAutoSuggestKeyPress = this.handleAutoSuggestKeyPress.bind(this);
    this.setError = this.setError.bind(this);
  }

  setError(error) {
    this.setState((prevState) => ({
      searchResult: Object.assign({}, prevState.searchResult, {
        error,
        isLoading: false,
      }),
    }));
  }

  handleSearchAbn(keyword) {
    const { onNewSearch, search } = this.props;
    const { searchResult } = this.state;
    onNewSearch();
    this.setState(
      {
        gridData: null,
        gridSelectedRowId: null,
        showGrid: false,
        searchResult: Object.assign({}, searchResult, {
          keyword,
          rows: [],
          isLoading: true,
        }),
      },
      () => {
        search(keyword)
          .then(({ data }) => {
            const { output, isSuccess, messages } = data;

            if (isSuccess) {
              const rows = output ? output.slice(0, 5) : null;
              this.setState((prevState) => ({
                searchResult: Object.assign({}, prevState.searchResult, {
                  rows,
                  isLoading: false,
                }),
              }));
            } else {
              this.setError(messages?.[0] ?? null);
            }
          })
          .catch(() => {
            this.setError('An error occurred. Try it again or please contact us.');
          });
      },
    );
  }

  handleShowSearchResultGrid() {
    const { gridData, searchResult } = this.state;

    if (gridData) {
      this.setState({ showGrid: true });
    } else {
      this.setState({
        gridData: searchResult.rows,
        showGrid: true,
      });
    }
  }

  handleAutoSuggestKeyPress(e) {
    const charCode = e.which || e.charCode;
    if (charCode === 13) {
      this.handleShowSearchResultGrid();
    }
  }

  handleRowSelection(_e, data) {
    const { onItemSelected } = this.props;
    onItemSelected(data);
  }

  handleSuggestionSelection(_e, data) {
    const { searchResult } = this.state;
    const { onItemSelected } = this.props;
    const abn = data.suggestion.id;
    const filteredRows = searchResult.rows.filter((x) => x.id === abn);
    this.setState({
      gridData: filteredRows,
      gridSelectedRowId: filteredRows.length === 1 ? filteredRows[0].id : null,
      showGrid: true,
    });
    onItemSelected(data.suggestion);
  }

  render() {
    const { classes, delay, fixedIdLabelValue } = this.props;
    const { gridData, gridSelectedRowId, showGrid, searchResult } = this.state;

    return (
      <Grid container spacing={1}>
        <Grid item xs={12} className={classes.searchBar}>
          <AbnAutoSuggest
            getSuggestions={this.handleSearchAbn}
            onSuggestionSelected={this.handleSuggestionSelection}
            suggestions={searchResult}
            onKeyPress={this.handleAutoSuggestKeyPress}
            autoFocus
            data-testid="abnAutoSuggest"
            delay={delay}
            fixedIdLabelValue={fixedIdLabelValue}
          />

          <Button
            appearance="primary"
            className={classes.searchButton}
            data-testid="search"
            onClick={this.handleShowSearchResultGrid}
          >
            <Icon>
              <SearchIcon />
            </Icon>
          </Button>
        </Grid>
        {showGrid && (
          <Grid item xs={12}>
            <AbnGrid
              data={gridData}
              selectedRowId={gridSelectedRowId}
              error={searchResult.error}
              onRowSelected={this.handleRowSelection}
              data-testid="abnGrid"
              fixedIdLabelValue={fixedIdLabelValue}
            />
          </Grid>
        )}
      </Grid>
    );
  }
}

AbnSearch.propTypes = {
  classes: PropTypes.object,
  search: PropTypes.func.isRequired,
  onItemSelected: PropTypes.func,
  onNewSearch: PropTypes.func,
  delay: PropTypes.number,
  fixedIdLabelValue: PropTypes.string,
};

AbnSearch.defaultProps = {
  classes: {},
  onItemSelected: null,
  onNewSearch: null,
  delay: 500,
  fixedIdLabelValue: null,
};

export default withStyles(styles)(AbnSearch);
